import gameAssets from '@themed-assets';
import Lottie from 'lottie-react';
import React from 'react'
import styles from './WinnerLottie.module.css'

export default function WinnerLottie({ tempTableId, winningPotData, multiPotAmounts, isWinner, isWinnerDeclared }) {
    if (!winningPotData && !multiPotAmounts) return;
    let animationArray = [gameAssets.redWinner, gameAssets.blueWinner, gameAssets.greenWinner, gameAssets.goldWinner, gameAssets.grayWinner];
    const totalPots = multiPotAmounts?.length;
    const pairIndex =
        winningPotData?.run === 1
            ? winningPotData?.potIndex
            : Math.abs(totalPots / 2 - winningPotData?.potIndex);
    const animationData = animationArray[pairIndex];

    return (
        isWinner &&
        isWinnerDeclared &&
        winningPotData && (
            // startWinnerPotAnimation &&
            <div className={styles.winnerLottieContainer}>
                <Lottie
                    style={{ width: "100%", height: "100%" }}
                    animationData={animationData}
                    autoPlay={true}
                    loop={true}
                />
            </div>
        )
    );
};
